export const selectLoading = (state) => state.shareReport?.loading;
export const selectError = (state) => state.shareReport?.error;
export const selectEmailData = (state) => state.shareReport?.emailData;
export const selectSuccess = (state) => state.shareReport?.success;